import { FC } from "react";
import { Route } from "nextjs-routes";
import { useRouter } from "next/router";

import { useBuilderContentPermissions } from "@src/components/libraryItemDetailPages/hooks/useBuilderContentPermissions";
import XIcon from "@ui/icons/18px/x";
import { cn } from "@src/ui/lib/utils";
import PenOutlineIcon from "@src/ui/icons/18px/pen-outline";
import { Button } from "@src/ui/button";

type Props = {
  titleComponent?: React.ReactNode;
  onTitleClick?: () => void;
  backRoute?: Route;
};

const LibraryItemDetailPageHeaderLeft: FC<Props> = (props) => {
  const { hasEditPermission } = useBuilderContentPermissions();
  const router = useRouter();
  const handleBackRoute = () => {
    if (props.backRoute) {
      router.push(props.backRoute);
    }
  };
  const handleTitleClick = () => {
    if (hasEditPermission && props.onTitleClick) {
      props.onTitleClick();
    }
  };
  return (
    <div className="mr-4 flex w-64 flex-1 items-center gap-2">
      {props.backRoute && (
        <div>
          <Button
            size="icon"
            variant="secondary"
            className="rounded-full shadow-none"
            onClick={handleBackRoute}
            data-testid="builder-header-back-button"
          >
            <XIcon />
          </Button>
        </div>
      )}
      <div
        onClick={handleTitleClick}
        className={cn(
          "group flex min-w-48 relative rounded-xl py-1 pr-8 pl-1 transition-colors duration-200 ease-in-out bg-background",
          hasEditPermission && props.onTitleClick
            ? "cursor-pointer hover:bg-gray-alpha-5"
            : "cursor-default",
        )}
      >
        {props.titleComponent}
        <div
          className={cn(
            "absolute inset-y-0 right-2 flex items-center opacity-0",
            hasEditPermission &&
              props.onTitleClick &&
              "group-hover:opacity-100",
          )}
        >
          <PenOutlineIcon className="text-muted-foreground" />
        </div>
      </div>
    </div>
  );
};

export default LibraryItemDetailPageHeaderLeft;
